export { default as PageTitleHeader } from "./PageTitleHeader";
export { default as ShortHeadline } from "./ShortHeadline";
export { default as SubHeader1 } from "./SubHeader1";
export { default as SubHeader2 } from "./SubHeader2";
export { default as SubHeader3 } from "./SubHeader3";
export { default as VideoTitleHeader } from "./VideoTitleHeader";
